import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const MB_SVG_Video = React.memo(
  (props: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The color of the component.
     */
    color?: string;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.size ?? 24}
          height={props.size ?? 24}
          viewBox="0 0 24 24"
          fill="none"
          stroke={props.color ?? 'white'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <Path d="M23 7L16 12 23 17 23 7z" />
          <Rect x={1} y={5} width={15} height={14} rx={2} ry={2} />
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_Video };
